import { classNames } from '../../../../model/helpers/classNameHelpers'
import React from 'react'
import { ProjectFormEnum } from '../../../../model/enums/ProjectFormEnum'
import { useProject } from '../../../../model/hooks/useProject'
import { useLocation, useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../../../../model/enums/RoutesEnum'
import { FormikProps, useFormikContext } from 'formik'
import { Tooltip } from '@chakra-ui/react'
import { CheckIcon } from '@radix-ui/react-icons'
import { useGetTechnicalFormsList } from '../../../../model/api/project/useGetTechnicalFormsList'
import { projectFormEnumToProjectFormCategory, TechnicalFormStatusEnum } from 'shared'

interface Props {
  title?: string
  projectFormEnum: ProjectFormEnum
}

export const TabsInPills: React.FC<Props> = (props) => {
  const { id } = useProject()
  const navigate = useNavigate()
  const location = useLocation()
  const formik = useFormikContext() as FormikProps<any>

  const { data: projectFormsListData, isLoading: projectFormsListIsLoading } =
    useGetTechnicalFormsList(id, projectFormEnumToProjectFormCategory(props.projectFormEnum))

  return (
    <div className="overflow-x-auto">
      <div className="block">
        <nav className="flex space-x-3" aria-label="Tabs">
          {(projectFormsListData?.data?.list?.b || []).map((tab, tabIndex) => {
            let current = false
            const splitTabType = tab.type.split('_')
            const tabFormNumber = splitTabType[splitTabType.length - 1]
            const splitUrlFormType = location.pathname
              .split('/')
              .find((x) => x.includes(tab.type))
              ?.split('?')[0]
              .split('_')
            if (
              splitUrlFormType &&
              splitUrlFormType[splitUrlFormType.length - 1] === tabFormNumber
            ) {
              current = true
            }
            return (
              <Tooltip label={tab.name}>
                <button
                  onClick={() => {
                    if (formik.dirty) {
                      formik.submitForm()
                    }
                    navigate(
                      `${RoutesEnum.PROJECTS}/${id}/${RoutesEnum.TECHNICAL_REPORT_FORM}/${tab.type}`,
                    )
                  }}
                  type="submit"
                  key={tab.name}
                  className={classNames(
                    current
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-500 hover:bg-blue-600 hover:text-white',
                    'rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap',
                  )}
                  aria-current={current ? 'page' : undefined}
                >
                  <div className="flex justify-center align-middle gap-1">
                    {tab.status === TechnicalFormStatusEnum.PREVIEW && (
                      <CheckIcon className="w-4 h-4 bg-white rounded-full text-blue-700 mt-[2px]" />
                    )}
                    {tab.identifier.split(' ').join('.')}
                  </div>
                </button>
              </Tooltip>
            )
          })}
        </nav>
      </div>
    </div>
  )
}
